import React from 'react';
import { Card } from '../ui/card';
import { Checkbox } from '../ui/checkbox';
import { CheckCircle, Circle } from 'lucide-react';

const VIEW_LABELS = {
  general_data: 'General Data',
  basic_data: 'Basic Data',
  sales: 'Sales',
  mrp: 'MRP',
  forecasting: 'Forecasting',
  plant_data_storage: 'Plant Data / Storage',
  production_resources_tools: 'Production Resources / Tools',
  accounting: 'Accounting'
};

const ViewSelector = ({ enabledViews, selectedViews, onViewToggle }) => {
  const selectedCount = Object.values(selectedViews).filter(v => v).length;

  return (
    <Card className="p-8 shadow-sm">
      <div className="mb-6">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-xl font-semibold text-gray-900">Select Data Views</h3>
          <span className="px-3 py-1 text-sm font-medium rounded-full bg-orange-100 text-orange-700">
            {selectedCount} views selected
          </span>
        </div>
        <p className="text-sm text-gray-600">
          Choose which sections you want to fill for this material. Some views are pre-selected based on the material type.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {Object.entries(VIEW_LABELS).map(([viewKey, viewLabel]) => {
          const isEnabledInType = enabledViews[viewKey] === true;
          const isSelected = selectedViews[viewKey] === true;
          const isMandatory = viewKey === 'general_data' || viewKey === 'basic_data';

          return (
            <div
              key={viewKey}
              onClick={() => !isMandatory && onViewToggle(viewKey, !isSelected)}
              className={`
                flex items-center space-x-3 p-4 rounded-lg border-2 transition-all
                ${isMandatory 
                  ? 'border-orange-500 bg-orange-50 cursor-not-allowed' 
                  : isSelected
                    ? 'border-green-500 bg-green-50 cursor-pointer hover:shadow-md'
                    : 'border-gray-200 bg-white cursor-pointer hover:border-gray-400 hover:shadow-sm'
                }
              `}
            >
              <div className="flex-shrink-0">
                {isSelected ? (
                  <CheckCircle className={`w-6 h-6 ${isMandatory ? 'text-orange-600' : 'text-green-600'}`} />
                ) : (
                  <Circle className="w-6 h-6 text-gray-400" />
                )}
              </div>
              
              <div className="flex-1">
                <label
                  className={`
                    text-sm font-medium cursor-pointer
                    ${isMandatory 
                      ? 'text-orange-900' 
                      : isSelected 
                        ? 'text-green-900' 
                        : 'text-gray-700'
                    }
                  `}
                >
                  {viewLabel}
                </label>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-6 p-4 bg-gray-50 border border-gray-200 rounded-lg">
        <p className="text-sm text-gray-700">
          <strong>Note:</strong> General Data and Basic Data are mandatory views and will always be included. 
          All other views can be selected or deselected based on your requirements.
        </p>
      </div>
    </Card>
  );
};

export default ViewSelector;
